define('Components/ReorderWidget/js/ReorderWidget',['hooks',
        'Components/ReorderWidget/js/views/ReorderWidgetInstanceView',
        'Components/ReorderWidget/js/models/ReorderWidgetInstanceModel'
    ],
    function(hooks,ReorderWidgetInstanceView, ReorderWidgetInstanceModel){

        return function(){
            hooks.registerWidgetInstance(
                'ReorderWidget',
                ReorderWidgetInstanceView,
                ReorderWidgetInstanceModel

            );
        }

});
